module.exports = __webpack_public_path__ + "img/transacciones.0b7c8c90.svg";